import ls from 'local-storage';

const KEY = {};

export const getValue = (key, defaultValue) => {
  const value = ls.get(key);
  if (value === null) return defaultValue;
  return value;
};

export const setValue = (key, value) => {
  if (value === undefined) return false;
  return ls.set(key, value);
};

export default {
  getValue,
  setValue,
  KEY,
};
